import { render } from "./OrderData.vue?vue&type=template&id=3338136e&scoped=true&ts=true"
import script from "./OrderData.vue?vue&type=script&lang=ts"
export * from "./OrderData.vue?vue&type=script&lang=ts"

import "./OrderData.vue?vue&type=style&index=0&id=3338136e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3338136e"]])

export default __exports__